export class setCurrentTemp {

  constructor(div = 'data-current-temp') {
    this.div = div; //falls back to updating a Div with the attribute 'data-current-temp'
    this.apiKey = process.env.MIX_OPENWEATHERMAP_API_KEY; // Assumes the API key is stored in an .env file
    this.apiLat = process.env.MIX_OPENWEATHERMAP_API_LAT; // Assumes the city name is stored in an .env file
    this.apiLon = process.env.MIX_OPENWEATHERMAP_API_LON; // Assumes the city name is stored in an .env file
    this.updateInterval = 60 * 60 * 1000; // 15 minutes in milliseconds

    if (!this.apiKey || !this.apiLat || !this.apiLon) {
      console.error('OpenWeatherMap API key or lAT/LON values not found. Please provide both values in your .env file.');
    } else {
      // Initialize and start updating temperature automatically
      this.init();
    }
  }

  async updateTemperature() {
    const apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${this.apiLat}&lon=${this.apiLon}&appid=${this.apiKey}&units=metric`;

    try {
      const response = await fetch(apiUrl);
      const data = await response.json();

      const temperature = data.main.temp;
      const elements = document.querySelectorAll(`[${this.div}]`);

      elements.forEach(element => {
        element.innerHTML = `EST ${temperature.toFixed(1)}°`; // Display temperature with one decimal place
        // element.innerHTML = `EST ${Math.round(temperature)}°`; // Display temperature to nearest integer
      });
    } catch (error) {
      console.error('Failed to fetch temperature data:', error);
    }
  }

  init() {
    // Call updateTemperature immediately
    this.updateTemperature();

    // Set up the periodic update
    setInterval(() => {
      this.updateTemperature();
    }, this.updateInterval);
  }
}

// Example usage with data attribute name 'data-current-temp'
// const temperatureUpdater = new setCurrentTemp();


